import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import AdminLayout from "./admin/layout/AdminLayout";
import AdminOverview from "./admin/pages/AdminOverview";
import AdminUsers from "./admin/pages/AdminUsers";
import AdminEvents from "./admin/pages/AdminEvents";
import AdminLogin from "./admin/pages/AdminLogin";
import EnquiriesPage from "./admin/pages/AdminEnquiries";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import ScrollToTop from "./admin/components/ScrollToTop";
import IdleLogout from "./admin/logout/UserLogout";
export default function App() {
  return (
    <>
    <BrowserRouter>
    <ScrollToTop />
    <IdleLogout minutes={15} />
      <Routes>
        <Route path="/" element={<Navigate to="/admin/login" replace />} />
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<AdminOverview />} />
          <Route path="users" element={<AdminUsers />} />
          <Route path="dashboard" element={<AdminOverview />} />
          <Route path="events" element={<AdminEvents />} />
          <Route path="enquiries" element={<EnquiriesPage />} />
        </Route>
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="*" element={<Navigate to="/admin/login" replace />} />
      </Routes>
    </BrowserRouter>
    <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnHover
        draggable
        theme="light"
      />
      </>
  );
}
